import { useEffect, useState } from "preact/hooks"

export default (props) => {
    const [data, setData] = useState([])
    
    useEffect(() => {
        fetch(`https://leaderboardb.swoogo-retrofit.tkevents.io/${props.eventId}/${props.quantity || 3}/leaderboard`).then(async res => {

            const json = await res.json()
            setData(json)
        })
    }, [])

    const spanStyle = {
        fontSize: ".7em"
    }

    const title = {
        1: <span style={spanStyle}>ST</span>,
        2: <span style={spanStyle}>ND</span>,
        3: <span style={spanStyle}>RD</span>,
        default: <span style={spanStyle}>TH</span>
    }

    return <div style={{
            ...(props.style || {}),
            position: "absolute",
            color: "white",
            fontFamily: `"Poppins", sans-serif`,
            fontWeight: 600,
            fontStyle: `normal`
        }}>
        <div style={{position: "relative", paddingLeft: "1vw", paddingRight: "1vw", overflow: "hidden"}}>
            <h2 style={{
                textAlign: "center", 
                marginBottom: 0,
                fontWeight: 500,
                fontSize: "1vw",
                lineHeight: "1.2em",
                marginTop: "2%"}}>LEADERBOARD</h2>
            <table style={{
                color: props.style.color || "white",
                fontSize: "1vw",
                width: "100%",
                borderSpacing: "0.4em",
                borderCollapse: "collapse"
            }}>
                {data.map((it, idx) => {

                    return <tr style={{
                        borderBottom: idx + 1 === data.length ? undefined : `2px solid ${props.style.color || "#ffffff70"}`,
                        height: "1vw",
                        textOverflow: "ellipsis"
                    }} ref={element => { 
                        if (element) element.style.setProperty('color', props.style.color || "white", 'important'); 
                    }}>
                        <td style={{fontSize: ".8em"}}>{idx + 1}{title[idx + 1] || title.default}</td>
                        <td style={{
                            width: "84%", 
                            fontWeight: 400,
                            height: "1vw",
                            overflow: "hidden",
                            whiteSpace: "nowrap"
                        }}>{it.name}</td>
                    </tr>
                })}

            </table>
        </div>
    </div>
}